import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Stats = () => {
  const { t } = useLanguage();

  return (
    <section className="border-y border-line bg-sand/60">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {t.stats.items.map((item) => (
            <div key={item.label} className="text-center lg:text-left">
              <p className="text-3xl sm:text-4xl font-extrabold text-teal font-heading">{item.value}</p>
              <p className="text-ink font-semibold text-sm mt-1">{item.label}</p>
              <p className="text-muted text-xs mt-0.5">{item.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
